import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getProductsCategories } from "../../api/apiProducts";
import { PAGE_SIZE } from "../../utils/constants";
import i18next from "i18next";

export function useProductsCategories(page) {
    const queryClient = useQueryClient();

    const {
        isLoading,
        data: productsCategories,
        error,
        isFetching
    } = useQuery({
        queryKey: ["categories", page, i18next.language],
        queryFn: () => getProductsCategories(page),
        retry: false,
    });

    // PRE-FETCHING
    const pageCount = Math.ceil(productsCategories?.length / PAGE_SIZE);
    
    if (page < pageCount)
        queryClient.prefetchQuery({
            queryKey: ["categories", page + 1],
            queryFn: () => getProductsCategories({ page: page + 1 }),
        });

    if (page > 1)
        queryClient.prefetchQuery({
            queryKey: ["categories", page - 1],
            queryFn: () => getProductsCategories({ page: page - 1 }),
        });
    return { isLoading, error, productsCategories, isFetching };
}
